export default __webpack_public_path__ + "static/media/calls-answered.395da3b5.svg";